export enum EGeoModalType {
  Region = 'region',
  Metro = 'metro',
  District = 'district',
}
